import { DefaultService } from '@/services/DefaultService';

export default class TipoAgendaAtividadeService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(tipo) {
        return this._http.post(`${this._env}/crm/tipo-agenda`, tipo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(obj){
        return this._http.post(`${this._env}/crm/tipo-agenda/updatesituacao`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/crm/tipo-agenda/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/crm/tipo-agenda/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    
    findAll(column = 'descricao', order = 'asc', page = 0, limit = 50, situacao, ...params) {
        return this._http.get(encodeURI(`${this._env}/crm/tipo-agenda.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params);
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/getcombo/scheduleactivitytype.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}